import React, { Component } from 'react';
import $ from "jquery";
import Steps from "./Steps";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import Pagination from "./Pagination";

class Wizard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            error: null,
        }
    }

    componentDidMount = () => {
        document.querySelector(".settings").style.display = "flex";
        this.height();
        $(window).off();
        $(window).on("resize", this.resize.bind(this));
    }

    setStep = (step) => {
        this.setState((prevState) => {
            prevState.step = step;
            return prevState;
        });
    }
    
    resize = () => {
        this.height();
    }

    height = () => {    
        let totalHeight = $(window).height();
        let heightHeader = $(".header").outerHeight();
        
        let available = totalHeight - heightHeader + "px";
        document.querySelector(".container").style.height = available;
    }

    step() {
        let step;
        switch(this.state.step) {
            case 1:
                step = <StepOne 
                            getdata={this.props.getdata} 
                            images={this.props.images}
                            setSex={this.props.setSex}
                            setTreatments={this.props.setTreatments}
                            setStylist={this.props.setStylist}
                            data={this.props.data}
                        />;
                break;
            case 2:
                step = <StepTwo 
                            dates={this.props.dates}
                            setDate={this.props.setDate}
                            data={this.props.data}
                        />;
                break;
            case 3:
                step = <StepThree  
                            getdata={this.props.getdata} 
                            images={this.props.images} 
                            times={this.props.times}
                            setTime={this.props.setTime}
                            setStylist={this.props.setStylist}    
                            data={this.props.data}
                        />;
                break;
            case 4:
                step = <StepFour 
                            getdata={this.props.getdata}
                            setSex={this.props.setSex}
                            setAck={this.props.setAck} 
                            data={this.props.data}
                        />;
                break;
            default:
                step = <StepOne getdata={this.props.getdata} />
        }
        return step;
    }

    checkTreatment = () => {
        let result = true;
        if (this.props.data.treatments.length === 0) {
          this.setState((prevState) => {
            prevState.error = "Kies eerst een behandeling voordat u naar de volgende stap kunt gaan!";
            return prevState;
          }, () => this.openModal('error'));
          result = false;
        }
        return result;
    }
    
    checkDate = () => {
        let result = true;
        if (!this.props.data.date) {
          this.setState((prevState) => {
            prevState.error = "Kies eerst een datum voordat u naar de volgende stap kunt gaan!";
            return prevState;
          }, () => this.openModal('error'));
          result = false;
        }
        return result;
    }

    checkTime = () => {
        let result = true;
        if (!this.props.data.time) {
          this.setState((prevState) => {
            prevState.error = "Kies eerst een tijd voordat u naar de volgende stap kunt gaan!";
            return prevState;
          }, () => this.openModal('error'));
          result = false;
        }
        return result;
    }

    checkAck = () => {
        let result = true;
        for (var prop in this.props.data.ack) {
            if (this.props.data.ack.hasOwnProperty(prop)) {
              if ((prop !== "Voorletters") && prop !== "Opmerking") {
                  if (this.props.data.ack[prop].length === 0) {
                    this.setState((prevState) => {
                        prevState.error = "Vul eerst alle verplichte velden in voordat u de aanvraag kunt bevestigen!";
                        return prevState;
                    }, () => this.openModal('error'));
                    result = false;
                  }
              }
            }
        }
        return result;
    }

    openModal = (name) => {
        $("." + name).addClass("is-active");
    }

    closeModal = (name) => {
            $("." + name).removeClass("is-active");
    }

    maxModal = () => {
    let cHeight = $(".container").height();
        return  (cHeight - 154) + "px";
    }

    render() {
        return (
        <React.Fragment>
            <div className="container">
                <Steps step={this.state.step} />
                {this.step()}
                <Pagination 
                    finish={this.props.finish}
                    step={this.state.step} 
                    setStep={this.setStep}
                    checkTreatment={this.checkTreatment}
                    checkDate={this.checkDate}
                    checkTime={this.checkTime}
                    checkAck={this.checkAck}
                    getDates={this.props.getDates}
                    getTimes={this.props.getTimes}
                    setPage={this.props.setPage}
                />
                <div className="modal error">
                    <div className="modal-background"></div>
                    <div className="modal-content">
                        <div className="cModal" style={{maxHeight: this.maxHeightModalContent}}>
                            <div className="cModal-header">
                                Fout
                            </div>
                            <div className="cModal-content stylists-content" style={{maxHeight: this.maxModal()}}>
                            {this.state.error}
                            </div>
                            <div className="cModal-footer">
                                <button className="button is-danger is-pulled-right" onClick={(e) => this.closeModal("error")}>Sluiten</button>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </React.Fragment>
        );
    }
}

export default Wizard;